
  export default {
    name: `RedirectPage`,
    options: {
      auth: false
    },
    mounted() {
      console.log(`Redirecting to client page...`)
      // redirect to client page
      window.location.assign(`/client`)
    }
  }
